// @ts-nocheck
import console from "../../log";
import { isCartRefreshRequest, scheduleInitialize } from "./cartRequests";
export default function XMLHttpRequestOverride(initialize) {
    // isEligble runs on every initialize(); only wrap XHR once per page or each
    // cart request fans out into one initialize() per previous initialize().
    if (window.__realIdXhrOverrideInstalled)
        return;
    window.__realIdXhrOverrideInstalled = true;
    console.log("Registering XML override");
    const open = window.XMLHttpRequest.prototype.open;
    function openReplacement(...args) {
        this.addEventListener("load", function () {
            if (isCartRefreshRequest(this.responseURL || args[1])) {
                scheduleInitialize(initialize);
            }
        });
        return open.apply(this, args);
    }
    window.XMLHttpRequest.prototype.open = openReplacement;
}
